import { createSlice } from '@reduxjs/toolkit';

import { fetchArticle } from './article.actions';
import { defaultArticleSlice, getArticleRequestKey } from './article.types';

const articleSlice = createSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchArticle.pending, (state, action) => {
                state.article = null;
                state.error = null;
                state.loaded = false;
                state.loading = true;
                state.requestKey = getArticleRequestKey(action.meta.arg);
            })
            .addCase(fetchArticle.fulfilled, (state, action) => {
                const incomingRequestKey = getArticleRequestKey(action.meta.arg);
                // Ignore stale responses from a prior navigation (pending already advanced requestKey).
                if (state.requestKey !== incomingRequestKey) {
                    return;
                }

                state.article = action.payload;
                state.error = null;
                state.loaded = true;
                state.loading = false;
            })
            .addCase(fetchArticle.rejected, (state, action) => {
                const incomingRequestKey = getArticleRequestKey(action.meta.arg);
                if (state.requestKey !== incomingRequestKey) {
                    return;
                }

                state.article = null;
                state.error = action.error.message || 'Unexpected error';
                state.loaded = true;
                state.loading = false;
            });
    },
    initialState: defaultArticleSlice,
    name: 'article',
    reducers: {},
});

export const { reducer: articleReducer } = articleSlice;
